import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import {getCurrencySymbol, getCurrencyName} from "./utils/currency";
import _, {filter, find, orderBy} from 'lodash';
import {formattingMoney, formattingPercent} from './utils/formatting'
import {map_money_list, map_portfolio_list} from './utils/mapping'
import Box from '@material-ui/core/Box';
import {Link, useHistory} from "react-router-dom";
import {Grid} from "@material-ui/core";
import {
    currencies,
    security_type_bond,
    security_type_cc,
    security_type_etf,
    security_type_selt,
    security_type_share, securityType
} from "../AppConstants";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 10
    },
    box: {
        width: '100%',
        overflowX: 'auto',
        marginBottom: 64
    },
    tr: {
        "&:hover": {
            backgroundColor: "#E8ECF2",
        }
    },
    hidden: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}));

function CurrencyList(props) {
    const money_list = props.money_list
    const currency = props.currency
    const classes = props.classes
    const balance = props.balance
    const sum_list = _.map(money_list,'summa_pc')
    const sum = _.sumBy(sum_list)

    if (money_list.length != 0) {
        return (
            <>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                >
                    <Typography variant="h5">
                        <Box component="div" display="inline" sx={{ fontWeight: 'bold'}}>Деньги</Box>
                    </Typography>
                    <Typography variant="h5">
                        <Box component="div" style={{ fontWeight: 'bold', marginRight:40}}  display="inline" >{formattingMoney(sum)} {currency}</Box>
                        <Box component="div" style={{ fontWeight: 'bold'}} color="primary.dark" display="inline">{formattingPercent(sum / balance * 100) + " %"}</Box>
                    </Typography>
                </Grid>
                <Box className={classes.box}>
                <Table aria-label="Деньги" size={'small'} className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Валюта</TableCell>
                            <TableCell align="right">Баланс</TableCell>
                            <TableCell align="right">Текущая стоимость</TableCell>
                            <TableCell align="right" className={classes.hidden}>Доля</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {money_list.map((row) => (
                            <TableRow key={row.name} className={classes.tr}>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body1">{getCurrencyName(row.currency)}</Typography>
                                    <Typography variant="overline">{row.currency}</Typography>
                                </TableCell>
                                <TableCell
                                    align="right">{formattingMoney(row.summa)} {getCurrencySymbol(row.currency)}</TableCell>
                                <TableCell align="right">{formattingMoney(row.summa_pc)} {currency}</TableCell>
                                <TableCell className={classes.hidden}
                                    align="right">{formattingPercent(row.summa_pc / balance * 100) + " %"}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                </Box>
            </>

        );
    } else return ""
}

function StocksList(props) {
    const {portfolio_list, currency, classes, balance, security_type} = props
    const history = useHistory();
    const security = find(securityType, x => x.value === security_type);

    const sum_list = _.map(portfolio_list,'summa_pc')
    const sum = _.sumBy(sum_list)
    if (portfolio_list.length != 0) {
        return (
            <>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                >
                    <Typography variant="h5">
                    <Box component="div" display="inline" sx={{ fontWeight: 'bold'}}> {security.label}</Box>
                    </Typography>
                    <Typography variant="h5">
                        <Box component="div" style={{ fontWeight: 'bold', marginRight:40}}  display="inline" >{formattingMoney(sum)} {currency}</Box>
                        <Box component="div" style={{ fontWeight: 'bold'}} color="primary.dark" display="inline">{formattingPercent(sum / balance * 100) + " %"}</Box>
                    </Typography>
                </Grid>
                <Box className={classes.box}>
                <Table aria-label="Бумаги" size={'small'} className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Актив</TableCell>
                            <TableCell align="right" className={classes.hidden}>Количество</TableCell>
                            <TableCell align="right" className={classes.hidden}>Средняя цена</TableCell>
                            <TableCell align="right">Сумма</TableCell>
                            <TableCell align="right">Прибыль</TableCell>
                            <TableCell align="right" className={classes.hidden}>Доля</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {portfolio_list.map((row) => (
                            <TableRow key={row.security_id} className={classes.tr} onClick={() => history.push(`/security/${row.security_id}`)} style={{ cursor: 'pointer'}}>
                                <TableCell component="th" scope="row">
                                    <Typography variant="body1">{row.name}</Typography>
                                    <Typography variant="overline" color='textSecondary'>{row.ticker}</Typography>
                                </TableCell>
                                <TableCell className={classes.hidden} align="right"><Typography
                                    variant="body2">{formattingPercent(row.q)} </Typography></TableCell>
                                <TableCell className={classes.hidden}
                                    align="right">{formattingMoney(row.price_average)} {getCurrencySymbol(row.currency)}</TableCell>
                                <TableCell align="right" >
                                    <Typography
                                        variant="body2">{formattingMoney(row.summa)} {getCurrencySymbol(row.currency)}</Typography>
                                    {getCurrencySymbol(row.currency) != currency && <Typography variant="overline"
                                                                                                color='textSecondary'>{formattingMoney(row.summa_pc)} {currency}</Typography>}
                                </TableCell>
                                <TableCell
                                    align="right"> <Box
                                    color={(row.summa - (row.price_average * row.q)) >= 0 ? "success.main" : "error.main"}>{formattingMoney(row.summa - (row.price_average * row.q))} {getCurrencySymbol(row.currency)}</Box>
                                </TableCell>
                                <TableCell className={classes.hidden}
                                    align="right">{formattingPercent(row.summa_pc / balance * 100) + " %"}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                </Box>
            </>
        );
    } else {
        return ''
    }
}


export default function PortfolioDetails(props) {

    const {portfolio, currency} = props
    const money_list = portfolio.money_list
    const classes = useStyles();

    const portfolio_list = map_portfolio_list(portfolio)
    return (
        <>
            <CurrencyList
                money_list={map_money_list(portfolio.money_list)}
                currency={currency}
                classes={classes}
                balance={portfolio.balance}
            />
            {portfolio_list[security_type_selt] != undefined &&
            <StocksList
                portfolio_list={portfolio_list[security_type_selt]}
                currency={currency}
                classes={classes}
                balance={portfolio.balance}
                securities={portfolio.s.securities}
            />
            }
            {portfolio_list[security_type_share] != undefined &&
            <StocksList
                portfolio_list={portfolio_list[security_type_share]}
                currency={currency}
                classes={classes}
                balance={portfolio.balance}
                security_type={security_type_share}
            />
            }
            {portfolio_list[security_type_bond] != undefined &&
            <StocksList
                portfolio_list={portfolio_list[security_type_bond]}
                currency={currency}
                classes={classes}
                balance={portfolio.balance}
                security_type={security_type_bond}
            />
            }
            {portfolio_list[security_type_etf] != undefined &&
            <StocksList
                portfolio_list={portfolio_list[security_type_etf]}
                currency={currency}
                classes={classes}
                balance={portfolio.balance}
                security_type={security_type_etf}
            />
            }
            {portfolio_list[security_type_cc] != undefined &&
            <StocksList
                portfolio_list={portfolio_list[security_type_cc]}
                currency={currency}
                classes={classes}
                balance={portfolio.balance}
                security_type={security_type_cc}
            />
            }
            <pre>
            {/*JSON.stringify(portfolio_list, null, 4)*/}
        </pre>
        </>
    );
}